import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";
import HeaderSearchBar from "@components/Main/Shared/HeaderSearchBar";
import Footer from "@components/Main/Shared/Footer";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import ContentBody from "./ContentBody";
import ContentSide from "./ContentSide";
import ContentHero from "./ContentHero";
import ContentSources from "./ContentSources";
import ContentBreadcrumbs from "./ContentBreadcrumbs";
import ContentSlideCTA from "./ContentSlideCTA";
import ContentSlideTOC from "./ContentSlideTOC";
import ContentAuthor from "./ContentAuthor";
import ContentFooter from "./ContentFooter";
import ContentTOCAlt from "./ContentTOCAlt";
import useStaticContext from "@hooks/useStaticContext";

import SchemaOrg from "@components/Global/Custom/SchemaOrg";
import schema from "./@data/schema.org";
import ContentBadge from "./ContentBadge";

const Content = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	const slideCTA = true; // should be handled at page type level / constants
	return (
		<React.Fragment>
			<link
				rel="stylesheet"
				href="https://cdn.jsdelivr.net/npm/katex@0.15.3/dist/katex.min.css"
				integrity="sha384-KiWOvVjnN8qwAZbuQyWDIbfCLFhLXNETzBQjA/92pIowpC0d2O3nppDGQVgwd2nB"
				crossorigin="anonymous"
			/>
			<Box /*ref={ref}*/ height="100%" position={"relative"}>
				<HeaderSearchBar fixed={true} />
				<article>
					{!!store.content.hero && (
						<ContentHero
							title={store.content.title}
							hero={store.content.hero}
						/>
					)}
					{slideCTA && <ContentSlideCTA />}
					{store.hasTableOfContents && <ContentSlideTOC />}

					{/* <Hidden lgUp>
						<Slide direction={"down"} in={trigger}>
							<Box
								position={"sticky"}
								top={{ xs: 104, md: 113, lg: 65 }}
								right={0}
								left={0}
								zIndex={1}
							>
								<LinearProgress
									variant="determinate"
									value={percentage.toPrecision(2) * 100}
									color="secondary"
									classes={{ colorSecondary: classes.linearRoot }}
								/>
							</Box>
						</Slide>
					</Hidden> */}

					<Container
						maxWidth={false}
						disableGutters
						className={classes.fullWrap}
					>
						<Box mb={22} display="flex">
							<Box width={"100%"} position="relative">
								<Container
									maxWidth={false}
									disableGutters
									className={classes.longContainer}
								>
									<ContentBreadcrumbs />

									<div className={classes.body}>
										{!store.content.hero && <h1>{store.content.title}</h1>}
										<ContentAuthor />

										{store.hasTableOfContents && <ContentTOCAlt />}

										<ContentBody />
									</div>
									<ContentSources />
									<SchemaOrg schema={schema(store)} />
								</Container>
							</Box>
							<Box
								flex={"0 0 auto"}
								width={400}
								minWidth={400}
								display={{ xs: "none", lg: "block" }}
								px={4}
								className={classes.contentSide}
							>
								<ContentSide />
							</Box>
						</Box>
					</Container>
				</article>

				<ContentFooter />
				<Footer />
			</Box>
		</React.Fragment>
	);
};

export default Content;
export const loader = (route) =>
	loadable(() => import("./Content.component"), { ssr: !!route.ssr });
